import { DEFENDER_THEMES } from './themes/standard/defender/index'
import { CRASH_THEMES } from './themes/standard/crash/index'
import { HOWZZAT_THEMES } from './themes/standard/howzzat/index'
import { COMET_THEMES } from './themes/unique/comet/index'

export const THEMES = {
  STANDARD: {
    DEFENDER: {
      DEFAULT: DEFENDER_THEMES?.DEFAULT,
      MOG: DEFENDER_THEMES?.MOG,
      PEPE: DEFENDER_THEMES?.PEPE,
    },
    CRASH: {
      DEFAULT: CRASH_THEMES?.DEFAULT,
      MOG: CRASH_THEMES?.MOG,
      PEPE: CRASH_THEMES?.PEPE,
    },
    HOWZZAT: {
      DEFAULT: HOWZZAT_THEMES?.DEFAULT,
      MOG: HOWZZAT_THEMES?.MOG,
      PEPE: HOWZZAT_THEMES?.PEPE,
    },
  },
  UNIQUE: {
    COMET: {
      DEFAULT: COMET_THEMES?.DEFAULT,
      MOG: COMET_THEMES?.MOG,
      PEPE: COMET_THEMES?.PEPE,
    },
  },
}
